var map = {
	"./template.betgalaxy": 1070,
	"./template.betgalaxy.tsx": 1070,
	"./template.betprofessor": 1071,
	"./template.betprofessor.tsx": 1071,
	"./template.betroyale": 2114,
	"./template.betroyale.tsx": 2114,
	"./template.default": 657,
	"./template.default.tsx": 657,
	"./template.fiestabet": 2015,
	"./template.fiestabet.tsx": 2015,
	"./template.forsport": 1072,
	"./template.forsport.tsx": 1072,
	"./template.puntcity": 1073,
	"./template.puntcity.tsx": 1073,
	"./template.puntgenie": 1074,
	"./template.puntgenie.tsx": 1074,
	"./template.questbet": 1075,
	"./template.questbet.tsx": 1075,
	"./template.ts": 287,
	"./template.volcanobet": 1076,
	"./template.volcanobet.tsx": 1076,
	"./template.wellbet": 2115,
	"./template.wellbet.tsx": 2115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2420;